import { Offer_Visible_Status } from '@occc/graphql';

import { EligibilityType, SourceFilterSelectOptionValueType } from './types';

import { useFilterParams } from '../../../utils';
import {
  OFFERS_BEFORE_PARAM,
  OFFERS_AFTER_PARAM,
  OFFERS_ENGAGEMENT_TYPE_PARAM,
  OFFERS_ELIGIBILITY_PARAM,
  OFFERS_VISIBLE_STATUS_PARAM,
} from '../../../constants';

export function useEngagementType() {
  return useFilterParams<SourceFilterSelectOptionValueType>(
    SourceFilterSelectOptionValueType,
    OFFERS_ENGAGEMENT_TYPE_PARAM,
    OFFERS_BEFORE_PARAM,
    OFFERS_AFTER_PARAM,
  );
}

export function useEligibility() {
  return useFilterParams<EligibilityType>(
    EligibilityType,
    OFFERS_ELIGIBILITY_PARAM,
    OFFERS_BEFORE_PARAM,
    OFFERS_AFTER_PARAM,
  );
}

export function useVisibleStatus() {
  return useFilterParams<Offer_Visible_Status>(
    Offer_Visible_Status,
    OFFERS_VISIBLE_STATUS_PARAM,
    OFFERS_BEFORE_PARAM,
    OFFERS_AFTER_PARAM,
  );
}
